export enum DocumentTypeEnum {
  'PDF',
  'Excel',
}
